import React, { useState, useEffect, useRef, useCallback, useReducer, useMemo } from "react";
import styled from "styled-components";

import img_c from './cap_c.png'

import "./style.css";
import { useTranslation } from "react-i18next";
import { resolveFileUrl } from "constants/config";



export default function PartnersProductsTool(props) {
    const { t, i18n } = useTranslation();
    let isRu = i18n.language === "ru";

    const PRODUCTS = [
        {
            id: "111",
            name: isRu ?  "Путешествие в науку. Санкт-Петербург" : "Journey into science. Saint Petersburg",
            description: "",
            partner: "Science ID",
            // image: img_c
            image: 'https://scienceid.net/upload/tourism/df/31/39de35f2_31.webp'
        },
        {
            id: "111",
            name: isRu ? "Путешествие в науку. Нижний Новгород" : "Journey into science. Nizhny Novgorod",
            description: "",
            partner: "Science ID",
            image: 'https://scienceid.net/upload/tourism/32/30/2fece185_30.jpg'
        },
        {
            id: "111",
            name: isRu ? "Путешествие в науку. Иркутск" : "Journey into science. Irkutsk",
            description: "",
            partner: "Science ID",
            image: 'https://scienceid.net/upload/tourism/ca/29/332b43ff_29.png'
        },
        {
            id: "111",
            name: isRu ? "Путешествие в науку. Обнинск - Калуга" : "Journey into science. Obninsk - Kaluga",
            description: "",
            partner: "Science ID",
            image: 'https://scienceid.net/upload/tourism/c2/27/a7699c7a_27.webp'
        },
        {
            id: "111",
            name: isRu ? "Путешествие в науку. Космодром Восточный" : "Journey into science. Vostochny Cosmodrome",
            description: "",
            partner: "Science ID",
            image: 'https://scienceid.net/upload/tourism/47/26/8c751467_26.jpg'
        },
        {
            id: "111",
            name: isRu ?  "Путешествие в науку. Калининград" : "Journey into science. Kaliningrad",
            description: "",
            partner: "Science ID",
            image: 'https://scienceid.net/upload/tourism/27/25/5bb55037_25.jpeg'
        },
        {
            id: "111",
            name: "Путешествие в науку. Новосибирск",
            description: "",
            partner: "Science ID",
            image: 'https://scienceid.net/upload/tourism/05/23/fcefd0b2_23.webp'
        },
        {
            id: "111",
            name: "Молодёжный фестиваль «Твой Дальний Восток»",
            description: "",
            partner: "Science ID",
            image: 'https://scienceid.net/upload/tourism/6c/20/3779ccca_20.png'
        },
        {
            id: "111",
            name: "Научно-популярная экскурсионная экспедиция в Оренбургскую область «Атмосфера неизведанной степи»",
            description: "",
            partner: "Science ID",
            image: 'https://scienceid.net/upload/tourism/95/19/818afe29_19.webp'
        },
        {
            id: "111",
            name: "Развитие научно-популярного туризма в регионах России Красноярский край: посещение научных, промышленных и природных объектов",
            description: "",
            partner: "Science ID",
            image: 'https://scienceid.net/upload/tourism/62/13/010a56fe_13.jpg'
        },
        {
            id: "111",
            name: "Научно-познавательный туристский маршрут «Ледник Романтиков» в рамках проекта «Исследуй Полярный Урал»",
            description: "",
            partner: "Science ID",
            image: 'https://scienceid.net/upload/tourism/67/12/4c13006b_12.jpg'
        },
        {
            id: "111",
            name: "Развитие научно-популярного туризма в регионах России Научные экспедиции на ледники юга Восточной Сибири",
            description: "",
            partner: "Science ID",
            image: 'https://scienceid.net/upload/tourism/db/9/78a6fa2b_9.jpg'
        },
        {
            id: "111",
            name: "Развитие научно-популярного туризма в регионах России Экскурсии в лаборатории",
            description: "",
            partner: "Science ID",
            image: 'https://scienceid.net/upload/tourism/c8/2/7ccff9a8_2.jpeg'
        }
    ];

    let arr = PRODUCTS;

    return (
        <Wrapper>

            {arr.map((a, i) => {
                return (
                    <div className="u-news-card u-news-list__item u-news-card--default">
                        <div className="u-news-card__inner">
                            <div className="u-news-card__preview">

                                <img
                                    src={resolveFileUrl(a.image)}
                                    alt="Под полярным солнцем: как сити-фермы позволят выращивать растения в любой точке мира"
                                    className="u-news-card__image" />
                            </div>
                            <div className="u-news-card__main green_bg">
                                <time className="u-news-card__date u-news-card__date--over-image"> {a.partner}</time>
                                <div className="u-news-card__info">
                                    <h3>
                                        {a.name}
                                    </h3>
                                    <button
                                        className="custom-button u-news-card__learn-more custom-button--size-sm custom-button--theme-outline-light">

                                        <span className="custom-button__content">
                                            { isRu ? 'Узнать больше' : 'Learn more'}
                                        </span>

                                    </button>

                                </div>
                            </div>
                        </div>

                    </div>
                );
            })}

        </Wrapper>
    );
}

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -8px;
`;
